module.exports = __webpack_public_path__ + "static/media/3.6ed53d84.jpg";